

import { Component, Vue } from "vue-property-decorator";
import { ParticaErrorData, ParticaConfirmConfig, } from "../../Models/Components.model";
import { State, Action, Getter } from "vuex-class";
import EventBus from "../../Plugins/eventbus";
import { ParticaServices, IParticaServices } from "../../BusinessServices/ParticaServices";
import { eParticaAction, ParticaEvent, getActionName } from "../../Models/ParticaEvent";
import { ButtonConfig, ButtonStatus } from "../../Models/Buttons";
import { actions } from "../../Store/config/actions";
const namespace: string = "config";
import axios from "axios";
import { IssueModel, IIssueModel, NavItemDTO } from "../../Generated/ParticaAPI";
import { INavigationService } from "../../NavigationServices/navigation";
import { BreadcrumbItem } from "../../Models/Breadcrumb";
import StateMixin from "../../Mixins/StateMixin";

@Component({
	name: "ParticaBaseView",
	mixins: [StateMixin]
})
export default class ParticaBaseView extends Vue {

	protected navData: NavItemDTO = new NavItemDTO();
	protected showerror: boolean = false;
	protected showhelp: boolean = false;
	protected pageTitle: string = "";
	protected component: string = "";
	protected errorinfo: ParticaErrorData = { error: null, friendly: "", apimessage: "", show: false } as ParticaErrorData;
	protected particaServices: IParticaServices = new ParticaServices();
	protected navigationService: INavigationService;

	protected breadcrumbs: BreadcrumbItem[] = [
	];

	protected dialog = {
		title: "Confirm.",
		message: "",
		show: false,
		item: undefined,
		action: eParticaAction.NONE,
		message2: ""
	} as ParticaConfirmConfig;

	protected navigate(name: string, params: any | undefined) {
		if (params === undefined) {
			this.$router.push(name).catch(err => { console.log("err"); });
		} else {
			this.$router.push({ name, params }).catch(err => { console.log("err"); });
		}
	}
	protected newtab(name: string, params: any | undefined) {
		if (params === undefined) {
			const route = this.$router.resolve(name);
			window.open(route.href, "_blank");
		} else {
			const route = this.$router.resolve({ name, params });
			window.open(route.href, "_blank");
		}
	}

	protected baseEventHandler(event: ParticaEvent) {
		switch (event.action) {
			case eParticaAction.SHOW_HELP: {
				this.ShowHelp();
				break;
			}
			case eParticaAction.SHOW_SNACKBAR: {
				this.ShowSnackbar(event.item as string);
				break;
			}
			default: {
				throw new Error(`Invalid event. ${getActionName(event.action)}`);
			}
		}
	}


	protected ShowErrorDialog(e: Error, friendlyMessage: string) {
		// move to business static errorUtils.GetFriendly(e) : ParticaErrorData
		let apimsg = "";
		let redirect: string = "";
		const r: any = e;
		if (r.response) {
			if (r.response.data.Message) {
				apimsg = r.response.data.Message;
			} else if (r.response.data.message) {
				apimsg = r.response.data.message;
			}
			if (r.response.status) {
				if (r.response.status === 401) {
					this.settoken("");
					this.setaccount(-1);
					localStorage.removeItem("auth");
					localStorage.removeItem("admin");
					localStorage.removeItem("user");
					axios.defaults.headers.common.Authorization = "";
					redirect = "login";
					this.ShowSnackbar("You login has expired, Please login again.");
				}
			}
		}
		this.showerror = true;
		if (this.$vnode !== undefined && this.$vnode.tag !== undefined) {
			this.component = this.$vnode.tag.substring(this.$vnode.tag.lastIndexOf("-") + 1);
		}
		this.errorinfo = {
			error: e,
			friendly: friendlyMessage,
			apimessage: apimsg,
			component: this.component,
			redirect,
			show: true
		} as ParticaErrorData;
		console.log(this.errorinfo);
	}
	protected ShowHelp() {
		this.showhelp = true;
	}
	protected CloseErrorDialog() {
		this.showerror = false;
		if (this.errorinfo.redirect !== "") {
			this.$router.push({ name: this.errorinfo.redirect });
		}
		this.errorinfo = { error: null, friendly: "", apimessage: "", redirect: "" } as ParticaErrorData;
	}
	protected ShowSnackbar(message: string) {
		EventBus.$emit("snackbar-event", { action: eParticaAction.NONE, item: message } as ParticaEvent);
	}
	protected ReloadMenu(goto: string) {
		EventBus.$emit("main-menu-event", {
			action: eParticaAction.MENU_RELOAD,
			item: goto
		} as ParticaEvent);
	}

	protected LoadingStart(msg: string = "") {
		EventBus.$emit("loading-start");
	}
	protected LoadingEnd(msg: string = "") {
		EventBus.$emit("loading-end");
	}

	protected raiseEvent(event: string, action: eParticaAction, item: any) {
		const pevent: ParticaEvent = { action, item } as ParticaEvent;
		this.$emit(event, pevent);
	}

	protected isLoggedIn(): boolean {
		// simplistic check for now.
		if (this.stateconfig.accountid > 0) {
			return true;
		}
		return false;
	}

	protected SetButtonStatus(buttons: ButtonConfig[], action: eParticaAction, status: ButtonStatus) {
		const btn: ButtonConfig | undefined = buttons.find(b => b.action === action);
		if (btn !== undefined) {
			btn.status = status;
		} else {
			console.log("Button not found." + getActionName(action));
		}
	}

	protected setPageTitle(title: string) {
		this.pageTitle = title;
		document.title = "Partica Dashboard : " + this.pageTitle;
	}

	protected trackEvent(name: string, data: any) {
		// @ts-ignore
		this.$appInsights.trackEvent(name, { user: this.stateconfig.user, data: JSON.stringify(data) });
	}

	private async created() {
		// @ts-ignore
		if (localStorage.auth === undefined) {
			this.navigate(this.errorinfo.redirect, undefined);
		}
		this.navigationService = this.particaServices.getNavigationService();
	}
}
